module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Application created","message":"You can now create roles for the application"},"da":{"title":"Applikation oprettet","message":"Du kan nu oprette administrer organisationens roller og tildele dem til organisationer."}}')
  delete Component.options._Ctor
}
